import React from 'react';
import { CTAButton } from './CTAButton';
import { finalSummary, trustItems } from '../data/offer';
import { pillars } from '../data/volumes';
export function FinalCTA() {
  return <section aria-labelledby="final-title" className="bg-navy text-white" data-id="element-54" data-mp="c6iuzupli37o">
      <div className="mx-auto max-w-3xl px-5 py-20 text-center sm:py-28" style={{
      paddingTop: "18px",
      paddingBottom: "24px"
    }} data-id="element-55" data-mp="c4ftoeizsnnn">
        <p className="text-sm font-semibold text-cyan" data-id="element-56" data-mp="m4f28bfewe0i">THE REALTOR AI PLAYBOOK™ · 100 AI Prompts for Leads, Listings, Follow-Up & Sales</p>
        <h2 id="final-title" className="mt-5 font-display text-3xl font-black leading-tight sm:text-5xl" data-id="element-57" data-mp="h5c8vo8snw8d">
          Turn AI into your real estate assistant.
        </h2>
        <p className="mt-4 font-display text-xl font-extrabold text-gold sm:text-2xl" data-id="element-58" data-mp="qvexzdcsoq1f">100 AI Prompts + 5 Bonuses</p>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/70" data-id="element-59" data-mp="14whk1q3si0cc">Turn a blank AI chat into a structured real estate workflow.</p>

        <p className="mt-6 text-xs font-bold uppercase tracking-[0.16em] text-white/45" data-id="element-60" data-mp="zua6iw3bac7w">{pillars.join(' → ')}</p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm text-white/80" data-id="element-61" data-mp="2c70xhm04e3p2">
          {finalSummary.map((s, i) => <li key={s} className="flex items-center gap-5" data-id="element-62" data-mp="2m2b0abycef3w" data-mpi={i}>
              {i > 0 && <span className="h-1 w-1 rounded-full bg-gold" aria-hidden="true" data-id="element-63" data-mp="2r1xg8t5k29ge" />}
              {s}
            </li>)}
        </ul>

        <div className="mt-10 flex justify-center" data-id="element-64" data-mp="2v4amdio7s9dp">
          <CTAButton data-id="element-65" data-mp="2v1g0dmpjygi6">Yes — Give me the Realtor AI Playbook™</CTAButton>
        </div>
        <p className="mt-4 text-sm font-semibold text-white/85" data-id="element-66" data-mp="300sn87gfbnkr">$27 · One-time payment · Lifetime Access</p>
        <p className="mt-1 text-xs text-white/50" data-id="element-67" data-mp="34vf06f25lo6y">Payment may be processed in your local currency.</p>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs text-white/60" data-id="element-68" data-mp="39uhsr00y61y1">
          {trustItems.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5" data-id="element-69" data-mp="3iu4xnvsvxpvu">
              <Icon className="h-3.5 w-3.5 text-cyan" aria-hidden="true" data-id="element-70" data-mp="1jo3g7dmw9z1x" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}